import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';

@Component({
  selector: 'app-add-attachment-checklist-template-modal',
  templateUrl: './add-attachment-checklist-template-modal.component.html',
  styleUrls: ['./add-attachment-checklist-template-modal.component.css']
})
export class AddAttachmentChecklistTemplateModalComponent implements OnInit {


  @Input() itemID: number;
  @Input() moduleID: number;
  @Input() active: boolean;
  @Input() status: any;
  @Input() mobileMode: boolean;
  formData: { [key: string]: any } = {};
  newFiles: any[] = [];
  savedFiles: any[] = [];
  fileData: any[] = [];
  alert: any = null;
  captionChanged: boolean = false;
  validComboDrag: boolean = false;
  dragFiles: any;
  errorMsg: any;
  lastSave: { [key: string]: any } = {};

  constructor(private employeeService: EmployeeService, private utilityService: UtilityService, private hiringService: HiringService, public HttpClient: HttpClient, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getAttachmentList();
  }

  getAttachmentList() {
    var requestParam = "moduleID=" + this.moduleID + "&recordID=" + this.itemID;
    this.employeeService.getFileAttachmentList(requestParam).then((response: any) => {
      if (response != null) {
        this.savedFiles = response;
        this.savedFiles.forEach((val: any) => {
          if (val.AttachmentCaption != null)
            val.TempAttachmentCaption = val.AttachmentCaption;
        });
      }
    }).catch((error: any) => {
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  deleteUnsavedAttachment(file: any) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
  }

  deleteSavedAttachment(file: any) {
    this.employeeService.removeFileAttachment(file.FileAttachmentID).then((response: any) => {
      if (response != null) {
        this.captionChanged = false;
        if (this.moduleID == 12) {
          this.employeeService.updateOnboardTaskComplete(this.itemID).then((result: any) => {
          }).catch((error: any) => {
            this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
          });
        }
        this.getAttachmentList();
      }
    }).catch((error: any) => {
      this.alert = { type: "danger", msg: error?.error?.error ?? "An error has occured." };
    });
  }

  upload() {
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      this.fileUpload(currentUpload[i]);
    }
    if (this.mobileMode) {
      setTimeout(() => {
        if (this.newFiles.length > 0) {
          $("#fileDrop").css("cursor", "no-drop");
        }
      }, 200);
    }
  }

  fileUpload(fileDrop: any) {
    this.fileData = [];
    if (fileDrop != null) {
      fileDrop.nameEdit = this.utilityService.formatAttachmentName(fileDrop.name);
      this.readFile(fileDrop, (e: any, fileName: string) => {
        setTimeout(() => {
          this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: fileName })
          this.fileData.forEach((val: any) => {
            if ((fileDrop.size == val.size && val.name == fileDrop.name) && ((this.moduleID == 38 && this.newFiles.length < 2 && (this.newFiles.length + this.savedFiles.length < 2)) || this.moduleID != 38)) {
              this.newFiles.push({ File: val.data[1], Filename: fileDrop.nameEdit, Filedata: fileDrop, Type: val.data[0].split("/")[0] });
            }
          });
        });
      });
    }
  }

  checkCaption() {
    this.captionChanged = false;
    this.savedFiles.forEach((val: any) => {
      if (val.TempAttachmentCaption != val.AttachmentCaption) {
        this.captionChanged = true;
        this.formData.disableButton = false;
      }
    });
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  uploadAttachment(counter: number, error: number) {
    var currentFile = this.newFiles[counter];
    var type = "file";
    var errMsg = "";
    if (currentFile.Type == "data:image")
      type = "Photo";
    if (currentFile.Progress != 100) {
      if (currentFile.File != null && currentFile.Filename != null) {
        var temp = currentFile.Type;
        var type = "file";
        if (temp == "data:image") {
          type = "Photo";
        }
        currentFile.Filedata.upload = new HttpRequest(
          "POST",
          "/Employee/SaveFileAttachment",
          { moduleID: this.moduleID, recordID: this.itemID, attachmentFileData: currentFile.File, attachmentFileName: currentFile.Filename, attachmentType: type }, { reportProgress: true }
        ),
          currentFile.Filedata.upload = this.HttpClient.request(currentFile.Filedata.upload).subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                currentFile.Progress = Math.round(event.loaded / event.total * 100);
                if (currentFile.Progress == 100) {
                  currentFile.AttchDone = true;
                }
                break;
              case HttpEventType.Response:
                setTimeout(() => {
                  currentFile.Filedata.result = event.body;
                });
                if (event.body.success) {
                  counter++;
                  if (counter < this.newFiles.length) {
                    this.uploadAttachment(counter, error)
                  }
                  if (counter == this.newFiles.length) {
                    this.formData.disableButton = false;
                    if (error == 0) {
                      this.newFiles = [];
                      if (this.captionChanged) {
                        this.savedFiles.forEach((val: any, key: any) => {
                          if (val.AttachmentCaption != val.TempAttachmentCaption) {
                            this.hiringService.fileAttachmentUpdateCaption(val.FileAttachmentID, val.AttachmentCaption).then((response: any) => {
                              if (response != null) {
                                this.fadeLabel(response.success);
                                val.TempAttachmentCaption = val.AttachmentCaption;
                                this.captionChanged = false;
                              }
                            });
                          }
                          if (key == this.savedFiles.length - 1) {
                            this.getAttachmentList();
                          }
                        });
                      } else {
                        this.getAttachmentList();
                      }
                    } else {
                      this.alert = { type: "danger", msg: errMsg + " failed to save one or more attachments - " };
                    }
                  }
                }
                else {
                  error++; counter++;
                  errMsg += currentFile.Filename + ",";
                  this.uploadAttachment(counter, error)
                }
            }
            error => this.errorMsg = error.message
          });
      }
    }
  }

  saveClicked() {
    this.formData.disableButton = true;
    if (this.newFiles.length > 0) {
      this.uploadAttachment(0, 0);
    } else {
      if (this.captionChanged) {
        this.savedFiles.forEach((val: any) => {
          if (val.AttachmentCaption != val.TempAttachmentCaption) {
            this.hiringService.fileAttachmentUpdateCaption(val.FileAttachmentID, val.AttachmentCaption).then((response: any) => {
              if (response != null) {
                this.fadeLabel(response.success);
                val.TempAttachmentCaption = val.AttachmentCaption;
                this.captionChanged = false;
                this.formData.disableButton = false;
              }
            });
          }
        });
      }
    }
  }

  closeClicked() {
    this.activeModal.close("close");
  }

  closeAlert() {
    this.alert = null;
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

}
